import React from 'react'
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box, FormHelperText, Grid, TextField } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CommonQuillEditor from 'common/editor';
import NoDataFound from 'common/component/NoDataFound';
import MDButton from 'components/MDButton';
import { Icon } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditableAccordionHeader from '../components/EditableAccordionHeader';
function FAQSection({
  faqOpen,
  setFaqOpen,
  formData,
  setFormData,
  errors,
  setErrors,
  updateFaqField,
  handleRemoveFaq,
  handleAddFaq,
  // Heading editing props
  sectionHeading,
  isEditingHeading,
  tempHeadingValue,
  setTempHeadingValue,
  onEditHeading,
  onSaveHeading,
  onCancelHeading,
}) {
  return (
    
    <Accordion
    className="home-page-faq"
    expanded={faqOpen}
    onChange={() => setFaqOpen(!faqOpen)}
  >
    <AccordionSummary
      expandIcon={<ExpandMoreIcon />}
      aria-controls="panelfaqSection-content"
      id="panelfaqSection-header"
    >
      <EditableAccordionHeader
        sectionKey="faqSection"
        heading={sectionHeading}
        isEditing={isEditingHeading}
        tempValue={tempHeadingValue}
        setTempValue={setTempHeadingValue}
        onEdit={onEditHeading}
        onSave={onSaveHeading}
        onCancel={onCancelHeading}
      />
    </AccordionSummary>
    <AccordionDetails>
      <Grid container direction="row" spacing={4}>
        <Grid item xs={12} md={6}>
          <Typography
            variant="body2"
            fontWeight="medium"
            color="#9A9AAF"
            mb={1}
            name="faqSectionSubData"
            style={{ fontSize: "14px" }}
          >
            Section Title (H2)
          </Typography>
          <TextField
            label=""
            className="form-input"
            fullWidth
            placeholder=""
            name="faqTitle"
            value={formData?.faqSection?.title}
            error={Boolean(errors?.faqTitle)}
            helperText={errors?.faqTitle}
            onChange={(e) => {
              setErrors((prev) => ({ ...prev, faqTitle: "" }));
              setFormData((prev) => ({
                ...prev,
                faqSection: {
                  ...prev.faqSection,
                  title: e.target.value,
                },
              }));
            }}
          />
        </Grid>
        {formData?.faqSection?.subData?.length === 0 && (
          <Grid item xs={12}>
            <Box sx={{ mt: 8 }}>
              <NoDataFound />
            </Box>
          </Grid>
        )}
        {(formData?.faqSection?.subData ?? []).map((item) => (
          <Grid item xs={12} key={item.faqId}>
            <Box width="100%" className="faq-sec-rep">
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                alignItems={"flex-start"}
                className="mb-3"
              >
                <Box
                  width={"100%"}
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  mb={1}
                >
                  <Typography
                    variant="body2"
                    fontWeight="medium"
                    color="#9A9AAF"
                    style={{ fontSize: "14px" }}
                    mb={1}
                  >
                    Question
                  </Typography>
                  {formData?.faqSection?.subData.length >= 1 && (
                    <MDButton
                      sx={{ gap: 0.5 }}
                      size="small"
                      variant="text"
                      style={{
                        color: "#fd4438",
                        minWidth: "auto",
                        padding: "5px",
                        minHeight: "auto",
                        background: "#ffffff",
                      }}
                      onClick={() => handleRemoveFaq(item.faqId)}
                    >
                      <DeleteIcon width="1rem" height="1rem" style={{ color: "#fd4438" }} />{" "}
                    </MDButton>
                  )}
                </Box>
                <Box width={"100%"} name={`faq_${item.faqId}_question`} className="remove-quill-mb">
                  <CommonQuillEditor
                    allowHeading={false}
                    // allowImage={false}
                    // value={faq?.question || ''}
                    // onChange={(value) => handleChangeFAQ(value, 'question', idx)}
                    value={item.question}
                    error={Boolean(errors[`faq_${item.faqId}_question`])}
                    helperText={errors[`faq_${item.faqId}_question`]}
                    onChange={(value) => {
                      setErrors((prev) => ({
                        ...prev,
                        [`faq_${item.faqId}_question`]: "",
                      }));
                      // setFormData((prev) => {
                      //   const updated = { ...prev };
                      //   updated.faqSection.subData[index].question = value;
                      //   return updated;
                      // });

                      updateFaqField(item.faqId, "question", value);
                    }}

                  //  value={item.heading}
                  />

                  {!!errors[`faq_${item.faqId}_question`] && (
                    <FormHelperText error>
                      {errors[`faq_${item.faqId}_question`]}
                    </FormHelperText>
                  )}
                </Box>
              </Box>
              <Box display="flex" justifyContent="center" alignItems={"flex-start"}>
                <Box width={"100%"} name={`faq_${item.faqId}_answer`}>
                  <Typography
                    variant="body2"
                    fontWeight="medium"
                    color="#9A9AAF"
                    style={{ fontSize: "14px" }}
                    mb={1}
                  >
                    Answer
                  </Typography>
                  <Box width={"100%"} className="remove-quill-mb">
                    <CommonQuillEditor
                      allowHeading={false}
                      // allowImage={false}
                      // value={faq?.answer || ''}
                      // onChange={(value) => handleChangeFAQ(value, 'answer', idx)}
                      value={item.answer}
                      error={Boolean(errors[`faq_${item.faqId}_answer`])}
                      onChange={(value) => {
                        setErrors((prev) => ({
                          ...prev,
                          [`faq_${item.faqId}_answer`]: "",
                        }));
                        updateFaqField(item.faqId, "answer", value);
                      }}
                    />
                    {!!errors[`faq_${item.faqId}_answer`] && (
                      <FormHelperText error>
                        {errors[`faq_${item.faqId}_answer`]}
                      </FormHelperText>
                    )}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
        ))}

        <Grid item xs={12}>
          <Box display="flex" justifyContent="space-between" alignItems={"center"}>
            <MDButton
              type="button"
              color="primary"
              size="medium"
              variant="outlined"
              sx={{ minWidth: "170px", fontSize: "14px" }}
              onClick={() => {
                handleAddFaq();
              }}
            >
              <Icon>add</Icon>&nbsp;Add FAQ
            </MDButton>
          </Box>
        </Grid>

        {/* <Grid item xs={12}>
          <MDButton
            type="button"
            color="primary"
            size="medium"
            variant="outlined"
            sx={{ minWidth: "170px", fontSize: "14px" }}
            // onClick={addFAQHandler}
          >
            <Icon>add</Icon>&nbsp;Add More
          </MDButton>
        </Grid> */}
      </Grid>
    </AccordionDetails>
  </Accordion>
  )
}

export default FAQSection